/**
 * Formato de lectura para nombres geográficos (DIVIPOLA en mayúsculas vs texto libre del admin).
 * Aplica tipo título en español por segmentos separados por coma.
 * No altera cadenas que parecen HTML.
 */

const LOWER_WORDS = new Set([
  "de",
  "del",
  "la",
  "las",
  "los",
  "el",
  "al",
  "y",
  "en",
  "por",
]);

function looksLikeHtml(s) {
  return /<[a-z][\s\S]*>/i.test(s);
}

function titleCaseSpanishWords(segment) {
  const words = segment.trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (words.length === 0) return segment.trim();
  return words
    .map((w, i) => {
      if (i > 0 && LOWER_WORDS.has(w)) return w;
      if (/^\d/.test(w)) return w;
      return w.charAt(0).toUpperCase() + w.slice(1);
    })
    .join(" ");
}

/**
 * @param {unknown} value
 * @returns {string} Texto formateado; cadena vacía si no hay contenido que mostrar.
 */
export function formatLugaresColombiaDisplay(value) {
  if (value == null) return "";
  const s = String(value).trim();
  if (!s) return "";
  if (looksLikeHtml(s)) return s;

  const parts = s
    .split(",")
    .map((p) => p.trim())
    .filter(Boolean);
  if (parts.length === 0) return s;
  return parts.map(titleCaseSpanishWords).join(", ");
}
